import { render, staticRenderFns } from "./ListChart.vue?vue&type=template&id=21a150c6&scoped=true&"
import script from "./ListChart.vue?vue&type=script&lang=js&"
export * from "./ListChart.vue?vue&type=script&lang=js&"
import style0 from "./ListChart.vue?vue&type=style&index=0&id=21a150c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a150c6",
  null
  
)

export default component.exports